// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VFfQX","largestCol":"styles_largestCol__9ku5o","smallestCol":"styles_smallestCol__RyCCz"};